/** Iter 639 — vendor panel split · 4-step wizard indicator
 * (moved verbatim from pages/PartnerProgramPage.jsx). */
import React from "react";
import { CheckCircle2 } from "lucide-react";

const STEPS = [
  { n: 1, label: "Register" },
  { n: 2, label: "Verify (KYC)" },
  { n: 3, label: "Connect payouts" },
  { n: 4, label: "Done" },
];

export default function StepIndicator({ v }) {
  const { step } = v;
  return (
    <ol className="mb-4 flex items-center gap-2" data-testid="partner-step-indicator">
      {STEPS.map((s, i) => {
        const done = step > s.n;
        const active = step === s.n;
        return (
          <li key={s.n} className="flex items-center gap-2 flex-1">
            <div
              className={`w-7 h-7 rounded-full grid place-items-center text-xs font-bold shrink-0 ${
                done
                  ? "bg-emerald-500 text-white"
                  : active
                  ? "bg-[color:var(--brand-blue)] text-white"
                  : "bg-slate-200 text-slate-500"
              }`}
              data-testid={`partner-step-${s.n}`}
              aria-current={active ? "step" : undefined}
            >
              {done ? <CheckCircle2 className="w-4 h-4" /> : s.n}
            </div>
            <div className={`text-xs font-semibold ${active ? "text-slate-900" : "text-slate-500"} hidden sm:block`}>
              {s.label}
            </div>
            {i < STEPS.length - 1 && <div className="flex-1 h-px bg-slate-200" />}
          </li>
        );
      })}
    </ol>
  );
}
